import { ActivePanelManager, Tabs } from '@infotech-soe/erp-ui-kit';
import React from 'react';

import { TabbedDatasetLayoutViewModel } from '../../../../services/category/view-model/DatasetLayoutViewModel';
import UniqueId from '../../../../services/uid/UniqueId';
import CategoryLayoutElementContainer from '../CategoryLayoutElementContainer';

interface Props {
  categoryId: UniqueId;
  element: TabbedDatasetLayoutViewModel;
  onActivateTab: (id: UniqueId) => void;
  activeTab: UniqueId;
  showCommands: boolean;
}

const CategoryTabs: React.FC<Props> = ({
  categoryId,
  element,
  activeTab,
  onActivateTab,
  showCommands,
}) => {
  const tabs = Array.from(element.children).map((_v, i) => ({
    title: element.titles[i],
    id: element.children[i],
  }));

  return (
    <Tabs
      className="full-height"
      active={activeTab}
      onTabActivate={onActivateTab}
    >
      {tabs.map(tab => (
        <Tabs.Pane key={tab.id} name={tab.id} label={tab.title}>
          <div
            className={`full-height ${ActivePanelManager.helpers.tabs}`}
            data-tab-context-id={tab.id}
          >
            <CategoryLayoutElementContainer
              categoryId={categoryId}
              elementId={tab.id}
              showCommands={showCommands}
            />
          </div>
        </Tabs.Pane>
      ))}
    </Tabs>
  );
};

export default CategoryTabs;
